export default __webpack_public_path__ + "static/media/login-left.8af9ebc4.svg";